import React, { FC, useState } from "react";
import axios from "axios";
import { Formik, Field, Form } from "formik";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";
import { Container, Row, Col, Card } from "react-bootstrap";

const AddNewTeamMember: FC = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [redirectAfterModal, setRedirectAfterModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");

  const callApiAddTeamMember = async (values: any) => {
    const url = `${process.env.REACT_APP_API_URL}ourteam/addteammate`;

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("designation", values.designation);
    formData.append("department", values.department);
    formData.append("description", values.description);
    formData.append("sequence", values.sequence);
    formData.append("linkedin", values.linkedin);
    formData.append("portfolio", values.portfolio);
    formData.append("twitter", values.twitter);
    if (selectedImage) {
      formData.append("image", selectedImage);
    }

    try {
      const token = localStorage.getItem("jwttoken") || "";
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });
      if (response.status === 200) {
        setModalMessage("Are you sure you want to add this team member?");
        setRedirectAfterModal(true);
        setShowModal(true);
      }
    } catch (error) {
      console.log(error);
      setFailureMessage("Failed to add team member. Please try again.");
      setShowFailureModal(true);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    if (redirectAfterModal) {
      setSuccessMessage("Team member added successfully!");
      setShowSuccessModal(true);

      setTimeout(() => {
        navigate("/ourteam");
      }, 3000);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Add New Team Member</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{
                  name: "",
                  designation: "",
                  department: "",
                  description: "",
                  sequence: "",
                  linkedin: "",
                  portfolio: "",
                  twitter: "",
                }}
                onSubmit={async (values, { resetForm }) => {
                  await callApiAddTeamMember(values);
                  resetForm();
                }}
              >
                <Form>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label htmlFor="name" className="form-label">
                        Name:
                      </label>
                      <Field
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="Enter Name"
                        required
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label htmlFor="designation" className="form-label">
                        Designation:
                      </label>
                      <Field
                        name="designation"
                        type="text"
                        className="form-control"
                        placeholder="Enter Designation"
                        required
                      />
                    </Col>
                  </Row>
                  <Row className=" mb-3">
                    <Col md={12}>
                      <label htmlFor="department" className="form-label">
                        Department:
                      </label>
                      <Field
                        name="department"
                        type="text"
                        className="form-control"
                        placeholder="Enter Department"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label htmlFor="description" className="form-label">
                        Description:
                      </label>
                      <Field
                        name="description"
                        as="textarea"
                        className="form-control"
                        placeholder="Enter Description"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label htmlFor="sequence" className="form-label">
                        Sequence:
                      </label>
                      <Field
                        name="sequence"
                        type="number"
                        className="form-control"
                        placeholder="Enter sequence"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label htmlFor="linkedin" className="form-label">
                        LinkedIn:
                      </label>
                      <Field
                        name="linkedin"
                        type="text"
                        className="form-control"
                        placeholder="Enter Linkedin id"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label htmlFor="portfolio" className="form-label">
                        Portfolio:
                      </label>
                      <Field
                        name="portfolio"
                        type="text"
                        className="form-control"
                        placeholder="Enter Portfolio"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label htmlFor="twitter" className="form-label">
                        Twitter:
                      </label>
                      <Field
                        name="twitter"
                        type="text"
                        className="form-control"
                        placeholder="Enter Twitter id"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <label
                        htmlFor="image"
                        className="col-sm-3 col-form-label"
                      >
                        Upload Image
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            setSelectedImage(e.target.files[0]);
                          }
                        }}
                        required
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col className="text-center">
                      <button type="submit" className="btn btn-success">
                        Add Team Member
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger ms-3"
                        onClick={() => navigate("/ourteam")}
                      >
                        Cancel
                      </button>
                    </Col>
                  </Row>
                </Form>
              </Formik>
              {/* Confirmation Modal */}
              <ConfirmationModal
                show={showModal}
                onHide={handleModalClose}
                modalMessage={modalMessage}
                operationType="Confirm"
              />
              <NewconfirmationModal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                modalMessage={successMessage}
                operationType="Ok"
                timeoutDuration={3000}
              />

              <AllFailureModal
                show={showFailureModal}
                onHide={() => setShowFailureModal(false)}
                modalMessage={failureMessage}
                operationType="Ok"
                timeoutDuration={5000}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddNewTeamMember;
